import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/layout/Navbar";
import Footer from "../../components/layout/Footer";
import "../../components/styles/notificationSettingsPage.scss";

/**
 * NotificationSettingsPage — MangoTV Notification Settings
 * Figma: Notification Settings
 *
 * Layout:
 *   - Navbar (fixed top)
 *   - Breadcrumb: "Setting > Notification setting"
 *   - Single card (neutral_900 bg, rounded_xl, padding 32px)
 *   - Title: "Notification Setting"
 *   - 8 notification rows with toggles
 *   - Footer below
 */

const NotificationSettingsPage = () => {
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState({
    general: false,
    events: false,
    news: false,
    sports: false,
    recommendations: false,
    contentRecommendations: false,
    scheduledReminders: false,
    notificationFrequency: false,
  });

  const handleToggle = (key) => {
    setNotifications((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const notificationItems = [
    {
      key: "general",
      title: "General notification",
      description: "Enable or disable general notifications for the latest information on events, movies, and news updates.",
    },
    {
      key: "events",
      title: "Event Notifications",
      description: "Enable or disable notifications about favorite sports events, movies, or TV series.",
    },
    {
      key: "news",
      title: "Latest News",
      description: "Enable or disable notifications for the latest news based on the user's interests (sports, entertainment, political news, etc.).",
    },
    {
      key: "sports",
      title: "Live Sports Streaming",
      description: "Enable or disable notifications about ongoing or upcoming live sports broadcasts.",
    },
    {
      key: "recommendations",
      title: "Content Recommendations",
      description: "Enable or disable content recommendation notifications based on the user's viewing history.",
    },
    {
      key: "contentRecommendations",
      title: "Content Recommendations",
      description: "Enable or disable content recommendation notifications based on the user's viewing history.",
    },
    {
      key: "scheduledReminders",
      title: "Scheduled Reminders",
      description: "Enable or disable reminders to notify users of upcoming special events or shows.",
    },
    {
      key: "notificationFrequency",
      title: "Notification Frequency",
      description: "Allow users to set how often they want to receive notifications (e.g., real-time, daily, weekly).",
    },
  ];

  return (
    <div className="notification-settings-page">
      {/* Navbar */}
      <Navbar activeTab="Settings" />

      {/* Main Content */}
      <div className="notification-settings-page__container">
        {/* Breadcrumb */}
        <div className="notification-settings-page__breadcrumb">
          <span className="notification-settings-page__breadcrumb-link" onClick={() => navigate("/settings")} style={{ cursor: "pointer" }}>Setting</span>
          <span className="notification-settings-page__breadcrumb-separator">/</span>
          <span className="notification-settings-page__breadcrumb-current">Notification setting</span>
        </div>

        {/* Settings Card */}
        <div className="notification-settings-page__card">
          <h1 className="notification-settings-page__title">Notification Setting</h1>

          {/* Notification Items */}
          <div className="notification-settings-page__items">
            {notificationItems.map((item, index) => (
              <div
                key={item.key}
                className={`notification-settings-page__row ${
                  index < notificationItems.length - 1
                    ? "notification-settings-page__row--border"
                    : ""
                }`}
              >
                {/* Left: Title and Description */}
                <div className="notification-settings-page__content">
                  <h3 className="notification-settings-page__item-title">{item.title}</h3>
                  <p className="notification-settings-page__item-description">
                    {item.description}
                  </p>
                </div>

                {/* Right: Checkbox */}
                <div className="notification-settings-page__checkbox-wrapper">
                  <input
                    type="checkbox"
                    className="notification-settings-page__checkbox"
                    checked={notifications[item.key]}
                    onChange={() => handleToggle(item.key)}
                    id={`notification-${item.key}`}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default NotificationSettingsPage;
